export function mapCityToOption(row) {
  if (!row?.id) return null;
  return {
    id: row.id,
    name: row.name,
    label: row.name,
    is_default: Boolean(row.is_default),
    is_active: row.is_active !== false
  };
}

export function mapCitiesToOptions(rows = []) {
  return rows.map(mapCityToOption).filter(Boolean);
}

export function getDefaultCity(cities = []) {
  return cities.find((c) => c.is_default) || cities[0] || null;
}

export function findCityById(cities, id) {
  if (id == null || id === '') return null;
  return cities.find((c) => String(c.id) === String(id)) || null;
}

export function findCityByName(cities, name) {
  const q = String(name || '').trim().toLowerCase();
  if (!q) return null;
  return cities.find((c) => String(c.name || '').trim().toLowerCase() === q) || null;
}

export function resolveCompanyCity(company, cities = []) {
  if (!company) return null;
  const byId = findCityById(cities, company.city_id);
  if (byId) return byId;
  if (company.city) {
    return findCityByName(cities, company.city) || { id: null, name: company.city, label: company.city };
  }
  return null;
}
